import {Component, Injector} from '@angular/core';
import {AbstractEditOrmComponent} from "../../AbstractEditOrmComponent";
import {Local} from "../../../../domain/Local";
import {Bioma} from "../../../../domain/Bioma";
import {TipoAreaAmostral} from "../../../../domain/enums";
import {EnumSincronizacao} from "../../../../domain/EnumSincronizacao";

@Component({
  selector: 'app-pessoa',
  templateUrl: './edit-local.component.html',
  styleUrls: ['./edit-local.component.scss'],
})
export class EditLocalComponent extends AbstractEditOrmComponent<Local>  {
  agenciavel = true
  biomas: Bioma[] = []
  tipos = Object.values(TipoAreaAmostral)
  target = Local
  override relations = ['biomas']
  urlListagem = "/cadastro/local"
  constructor() {
    super()
    this.ds.getRepository(Bioma).find().then(b=> this.biomas = b)
  }

  protected override async saveInternal(): Promise<void> {
    this.entidade.situacao = EnumSincronizacao.ENVIAR
    const idPai = this.route.snapshot.paramMap.get('pai')
    if(idPai) this.entidade.pai= await  this.service.findOneOrFail({where: {id: idPai}})
    console.log(this.entidade)
    await super.saveInternal();
  }
}
